import { css } from "@emotion/react";

export const root = css`
  display: flex;
  gap: 10px;
  flex-direction: column;
`;
